import React from 'react';
import PropTypes from 'prop-types';
import fallbackImage from '@assets/boy_magnifying_glass_butterfly.jpg';
import {containerPx} from '@/features/microsite/constants';

MicrositeHero.propTypes = {
  image: PropTypes.string,
  headingPrefix: PropTypes.node,
  headingHighlight: PropTypes.node,
  subtitlePrefix: PropTypes.node,
  subtitleBold: PropTypes.node,
  pills: PropTypes.node
};

export default function MicrositeHero(props) {
  const {
    image,
    headingPrefix,
    headingHighlight,
    subtitlePrefix,
    subtitleBold,
    pills
  } = props;

  const heroImage = image || fallbackImage;

  return (
    <section className="relative bg-cs-navy-600">
      <div
        className="absolute inset-0 bg-cover bg-top"
        style={{backgroundImage: `url(${heroImage})`}}
        aria-hidden="true"
      />
      <div
        className="absolute inset-0 bg-gradient-to-r from-[rgba(22,39,70,0.85)] via-[rgba(22,39,70,0.55)] to-[rgba(30,38,62,0.15)]"
        aria-hidden="true"
      />
      <div className={`relative ${containerPx} pt-16 pb-[152px] md:pt-24 md:pb-[184px]`}>
        <h1
          className="font-extrabold text-white text-[34px] leading-[1.1] md:text-[44px] lg:text-[52px] lg:leading-[60px] max-w-[820px]">
          {headingPrefix}{' '}
          <span className="text-cs-yellow-500">{headingHighlight}</span>
        </h1>
        <p className="mt-6 text-white max-w-[680px] text-lg md:text-2xl leading-snug">
          {subtitlePrefix}
          <span className="font-bold">{subtitleBold}</span>
        </p>
        <div className="flex flex-wrap gap-3 mt-8">
          {pills}
        </div>
      </div>
    </section>
  );
}
